<footer class="h-8 flex items-center justify-center gap-8 bg-preorder-background-top text-preorder-white {{branding}}">
    <a [routerLink]="'/impressum'">Impressum</a>
    <a [routerLink]="'/agb'">AGB</a>
    <a [routerLink]="'/datenschutz'">Datenschutz</a>
</footer>
